import { adminApiBaseUrl } from "../config/api";

function normalizeEnvBase(url) {
  if (!url) return url;
  const trimmed = url.replace(/\/+$/, "");
  if (/^https?:\/\//i.test(trimmed) || trimmed.startsWith("/")) return trimmed;
  return `/${trimmed}`;
}

let API_BASE_URL = process.env.REACT_APP_API_BASE_URL
  ? normalizeEnvBase(process.env.REACT_APP_API_BASE_URL)
  : adminApiBaseUrl();

if (typeof window !== "undefined") {
  const isLocalDev = ["localhost", "127.0.0.1"].includes(window.location.hostname) && window.location.port === "3000";
  if (isLocalDev) {
    // Use the local Apache backend URL directly in CRA dev to avoid proxy and CORS issues.
    API_BASE_URL = "http://localhost/Ashoka/backend/admin";
  }
}

async function request(path, options = {}) {
  const response = await fetch(`${API_BASE_URL}/${path}`, {
    credentials: "include",
    ...options,
    headers: {
      ...(options.body instanceof FormData ? {} : { "Content-Type": "application/json" }),
      ...options.headers,
    },
  });

  const contentType = response.headers.get("content-type") || "";
  const data = contentType.includes("application/json")
    ? await response.json().catch(() => ({}))
    : {};

  if (!response.ok || data.success === false) {
    throw new Error(
      data.message ||
        "Admin API did not return JSON. Check that the backend folder is uploaded and .htaccess excludes /backend."
    );
  }

  return data;
}

export function loginAdmin(credentials) {
  const body = new URLSearchParams();
  body.set("username", credentials.username);
  body.set("password", credentials.password);

  return request("login.php", {
    method: "POST",
    body,
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
}

export function logoutAdmin() {
  return request("logout.php", { method: "POST" });
}

export function loadSeoFiles() {
  return request("seo-files.php");
}

export function saveSeoFiles({ robotsText, sitemapText, robotsFile, sitemapFile }) {
  const formData = new FormData();
  formData.set("robots_text", robotsText || "");
  formData.set("sitemap_text", sitemapText || "");

  if (robotsFile) {
    formData.set("robots_file", robotsFile);
  }

  if (sitemapFile) {
    formData.set("sitemap_file", sitemapFile);
  }

  return request("seo-files.php", {
    method: "POST",
    body: formData,
  });
}

export function loadSeoMeta() {
  return request("seo-meta.php");
}

export function saveSeoMeta(payload) {
  return request("seo-meta.php", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function loadAnalytics() {
  return request("ga.php");
}

export function saveAnalytics(payload) {
  return request("ga.php", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function getDashboard() {
  return request("dashboard.php");
}

export function getBlogs(search = "") {
  const query = search ? `?search=${encodeURIComponent(search)}` : "";
  return request(`blogs.php${query}`);
}

export function createBlog(formData) {
  return request("blogs.php", {
    method: "POST",
    body: formData,
  });
}

export function deleteBlog(id) {
  return request("delete-blog.php", {
    method: "POST",
    body: JSON.stringify({ id }),
  });
}
